<template>
  <div :class="`quick-access col-lg-${options.colSize || 6}`">
    <list-groups :options="options">

        <span slot="action" class="label label-success">
          {{ pagination.total }}
        </span>

      <b-list-group-item
        slot="card"
        v-for="item in items"
        :key="item.id" :href="options.link.href + item.id || '#!'"
        :target="options.link.target || '_self'"
        class="flex-column align-items-start quick-access">

        <div class="d-flex w-100 justify-content-between">
          <h5 class="col-lg-8 alpha no-margin" v-if="item.name">
            {{ item.name }}
          </h5>
          <small class="col-lg-4 omega text-right" v-if="item.created_at" style="padding-top: 4px;">
            <b><i class="fa fa-clock-o" aria-hidden="true"></i> {{ item.created_at | moment('DD/MM/YYYY HH:mm') }}</b>
          </small>
        </div>
        <!-- <ul class="list list-content alpha">
          <li>
            <span v-if="item.email">Email : <i>{{ item.email }}</i><br/></span>
          </li>
          <li>
            <span v-if="item.roles[0].name">Perfil : <i>{{ item.roles[0].name }}</i><br/></span>
          </li>
          <li>
            <span v-if="item.phone_number">Telefone : <i>{{ item.phone_number }}</i><br/></span>
          </li>
          <li>
            <span v-if="item.document">Documento : <i>{{ item.document }}</i><br/></span>
          </li>
        </ul> -->
      </b-list-group-item>
    </list-groups>
</div>
</template>

<script>
import { resolveHTTP } from '@/services/api'

export default {
  name: 'widget-system-user',
  data () {
    return {
      items: [],
      pagination: [],
      options: {
        name: 'Últimos usuários cadastrados',
        caption: '',
        icon: 'fa fa-users',
        colSize: 6,
        entity: {
          url: '/system/users',
          params: {
            per_page: 5,
            _order: 'id:desc'
          }
        },
        link: {
          href: '/#/sys-users/',
          target: '_self'
        }
      }
    }
  },
  methods: {
    refresh () {
      let self = this
      resolveHTTP(self.options.entity.url).index({
        params: self.options.entity.params
      }).then(function (res) {
        self.items = res.data.collection
        self.pagination = res.data.pagination
      })
    }
  },
  created () {
    this.refresh()
  }
}
</script>

<style lang="scss" scoped>
  .card-header {
    .card-actions {
      .label {
       padding: 5px 10px;
       border-radius: 2px;
     }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/widgets/System/User.vue